import React, { useState } from 'react'
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu'
import EditMenu from '../editMenu'
import DeleteModal from '../../DeleteModal/DeleteModal'
import { withTheme } from 'theming'
import AddSection from '../addSection'
import CustomImage from '../../customImage/customImage'
import useTemplateHook from '../templateHook'

const StaggeredCardCarousel = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
}) => {
  const { customNavigate, getTemplateImage, EditIcon, KalingoLeftArrow, KalingoRightArrow } =
    useTemplateHook()
  const { data, id, config } = componentData
  const [hoverState, setHoverState] = useState('')
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedCardIndex, setSelectedCardIndex] = useState('')

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const deleteCard = (index) => {
    setSelectedCardIndex(index)
    setDeleteModal(true)
  }

  const handleModal = (cardInfo, type, cardIndex, isEdit) => {
    setModalState({
      keyID: id,
      modalData: cardInfo,
      type: type,
      cardIndex: cardIndex,
      isEdit,
    })
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  const onDeleteCard = () => {
    let tempdata = data
    tempdata?.card_data.splice(selectedCardIndex, 1)
    modifyData(id, tempdata)
    setDeleteModal(false)
    setSelectedCardIndex('')
  }

  function LeftArrow() {
    const { isFirstItemVisible, scrollPrev } = React.useContext(VisibilityContext)

    return (
      <button
        className={` absolute left-0 top-[45%] sm:top-[225px] z-10 bg-transparent px-0 hidden lg:flex justify-center ${
          isFirstItemVisible ? 'opacity-0' : 'opacity-100'
        }`}
        disabled={isFirstItemVisible}
        onClick={() => scrollPrev()}
        title="Previous Item"
        style={{ width: '3.66032%' }}
      >
        <img src={KalingoLeftArrow} style={{ height: '37px' }} alt="KalingoLeftArrow" />
      </button>
    )
  }

  function RightArrow() {
    const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext)
    return (
      <button
        className={`absolute right-0 top-[45%] sm:top-[225px] z-10 bg-transparent px-0 hidden lg:flex justify-center ${
          isLastItemVisible ? 'opacity-0' : 'opacity-100'
        }`}
        disabled={isLastItemVisible}
        onClick={() => scrollNext()}
        title="Next Item"
        style={{ width: '3.66032%' }}
      >
        <img src={KalingoRightArrow} style={{ height: '37px' }} alt="KalingoLeftArrow" />
      </button>
    )
  }

  return (
    <div
      style={{
        padding: '0px 3.66032%',
      }}
      className={` w-full relative  ${isEdit && hoverState && 'component-hover-class'}`}
      onMouseEnter={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
          onCopy={() => onCopy(id)}
        />
      )}

      <h1
        style={{ color: '#fd8800' }}
        className={`  w-fit uppercase mb-3 xl:text-2xl md:text-xl text-xs font-bold relative ${
          isEdit && hoverState === 'HEADING' && 'component-hover-class'
        }`}
        onMouseOver={() => handleHoverItems('HEADING')}
        onMouseLeave={() => handleHoverItems('TOP')}
      >
        {data?.title}
        {hoverState === 'HEADING' && (
          <div
            className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-2 -right-3 flex justify-center items-center cursor-pointer"
            onClick={() => handleModal({ title: data?.title }, 'HEADING', 0, true)}
          >
            <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
          </div>
        )}
      </h1>

      <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow}>
        {data?.card_data &&
          data?.card_data.map((cardInfo, index) => (
            <Card
              key={index}
              itemId={`index${index}`}
              index={index}
              cardInfo={cardInfo}
              config={config}
              handleRedirect={handleRedirect}
              isEdit={isEdit}
              hoverState={hoverState}
              theme={theme}
              handleHoverItems={handleHoverItems}
              handleModal={handleModal}
              deleteCard={deleteCard}
              getTemplateImage={getTemplateImage}
            />
          ))}
      </ScrollMenu>

      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}

      {deleteModal && (
        <DeleteModal
          openModal={deleteModal}
          title={`Are you sure you want to delete this Card ?`}
          confirmButtonText={`Yes`}
          onCancel={() => {
            setSelectedCardIndex('')
            setDeleteModal(false)
          }}
          onConfirm={onDeleteCard}
        />
      )}
    </div>
  )
}

function Card({
  index,
  cardInfo,
  config,
  handleRedirect,
  isEdit,
  hoverState,
  theme,
  handleHoverItems,
  handleModal,
  deleteCard,
  getTemplateImage,
}) {
  const { PlusIcon, EditIcon, TrashIcon, VideoPlaceholder } = useTemplateHook()

  return (
    <div
      key={index}
      className={`flex cursor-pointer ${!isEdit && index > 0 ? 'ml-4' : ''}`}
      onClick={() => handleRedirect(cardInfo.link)}
      tabIndex={0}
    >
      <div
        className={`${config[cardInfo.size].styleClass}  ${
          isEdit && hoverState === `CARD${index}` && 'component-hover-class'
        } static-img-scale-120`}
        onMouseOver={() => handleHoverItems(`CARD${index}`)}
        onMouseLeave={() => handleHoverItems('TOP')}
      >
        {hoverState === `CARD${index}` && (
          <div className={`relative ${config[cardInfo.size].styleClass}`}>
            <div className={`mt-2 absolute w-full top-3 flex justify-center items-center`}>
              <span className={`text-[#2172eb] text-sm`}>
                {cardInfo.size === 'sm'
                  ? '382px X 597px'
                  : cardInfo.size === 'md'
                  ? '597px X 597px'
                  : '764px X 597px'}
              </span>
            </div>

            <div
              className={`absolute w-full top-3 ${
                cardInfo.size === 'sm' ? 'right-0' : 'right-4'
              } flex justify-end items-center`}
            >
              <div
                className="mx-[8px] h-[32px] w-[32px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer"
                onClick={() => handleModal(cardInfo, 'CARD', index, true)}
              >
                <img src={EditIcon} className="w-[17px] h-[17px]" alt="editicon" />
              </div>
              <div
                className="mx-[8px] h-[32px] w-[32px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer"
                onClick={() => deleteCard(index)}
              >
                <img src={TrashIcon} className="w-[17px] h-[17px]" alt="trashicon" />
              </div>
            </div>
          </div>
        )}
        <div className={`sm:h-[399px] h-[356px] sm:mb-3 w-full overflow-hidden `}>
          <CustomImage
            imageUrl={getTemplateImage(cardInfo.image_s3key)}
            imgClass="  max-w-none w-full h-full"
            loaderClass="w-full h-full sm:mb-3"
            loaderStyle={{ background: '#5A5A5A50' }}
            imgAlt={'card img'}
            errorPlaceholder={VideoPlaceholder}
          />
        </div>
        <p
          style={{ color: `#ffffff`, fontWeight: 600 }}
          className={`font-semibold text-sm sm:text-base mb-2`}
        >
          {cardInfo.heading}
        </p>
        <span
          style={{ color: `#fd8800`, borderBottom: `1.5px solid #eeeeee` }}
          className={` text-[11px] font-normal  inline-block sm:mb-2.5`}
        >
          {cardInfo.sub_heading}
        </span>
        <p style={{ color: '#b5b5b5' }} className={`text-xs`}>
          {cardInfo.description}
        </p>
      </div>
      <div
        className={`${
          isEdit ? '' : 'hidden'
        } rosemary-toptrending-add-button d-flex justify-content-center align-items-center h-[477px] py-10`}
      >
        <div style={{ border: '1px solid #2172eb' }} className="relative h-full">
          <div
            onClick={() => handleModal(cardInfo, 'CARD', index, false)}
            className="absolute h-[32px] w-[32px] rounded-full bg-[#2172eb] top-[45%] -left-4 flex justify-center items-center"
          >
            <img src={PlusIcon} className="w-[17px] h-[17px]" alt="plus icon" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTheme(StaggeredCardCarousel)
